<div class="column-layout-container">
  <div class="menu animate-in-from-left" [class.mobile-shown]="appService.mobileMenuShown">
    <div class="menu-top d-flex justify-content-between align-items-center">
      <fui-heading [text]="'com.messages' | translate" [level]="2" fontSize="f7"></fui-heading>
      <div>
        <button class="fa-button m-r-10" placement="bottom" [ngbTooltip]="'com.send_new_message' | translate" (click)="showCreateMessage()">
          <fa-icon icon="plus" class="action create-action circle-icon-btn"></fa-icon>
        </button>
      </div>
    </div>

    <myp-inline-loader [loading]="loading" height="200px" spinnerName="messagesLoader"></myp-inline-loader>

    @if (!loading && !threads?.length) {
      <div class="m-y-20 m-x-10">{{ "com.no_messages" | translate }}</div>
    }
    @if (threads && threads.length) {
      <div>
        @if (threads.length > 3) {
          <div class="item-filter m-r-10 m-b-10">
            <div class="filter-input no-max-width">
              <input type="text" [(ngModel)]="filter" (ngModelChange)="doFilter()" [placeholder]="'com.type_to_filter' | translate" />
              @if (filter) {
                <div class="clear" (click)="filter = ''; doFilter()"><fa-icon icon="times"></fa-icon></div>
              }
            </div>
          </div>
        }
        <ul class="menu-options">
          @for (thread of displayedThreads; track thread) {
            <ng-container *ngTemplateOutlet="threadItem; context: { thread, archived: false }"></ng-container>
          }
          @if (archivedThreadsVisible) {
            @for (thread of archivedThreads; track thread) {
              <ng-container *ngTemplateOutlet="threadItem; context: { thread, archived: true }"></ng-container>
            }
          }
          <li class="menu-option">
            @if (archivedThreads.length && !filter) {
              <button class="small-btn d-block mx-auto my-3" (click)="toggleArchivedThreads()">
                @if (!this.archivedThreadsVisible) {
                  <span>View</span>
                }
                @if (this.archivedThreadsVisible) {
                  <span>Hide</span>
                }
                Archived Threads
              </button>
            }
          </li>
        </ul>
      </div>
    }
  </div>
  <div class="content animate-in-from-right" id="messages-cmp-content" [class.mobile-shown]="!appService.mobileMenuShown">
    <div class="mobile-back-btn" (click)="appService.mobileMenuShown = true">
      <fa-icon icon="chevron-left"></fa-icon>
      {{ "com.messages" | translate }}
    </div>

    <div class="content-constrained">
      @if (!selectedThread) {
        @if (noThreadSelected) {
          <div class="w-full h-full d-flex justify-content-center align-items-center">
            <span class="m-y-100">{{ "com.no_convo_selected" | translate }}</span>
          </div>
        }
      }
      @if (selectedThread) {
        <myp-messages-detail #messageDetailCmp (unsupportedFileChosen)="unsupportedFileChosen($event)" (threadUnarchived)="setupThreads()" [thread]="selectedThread"></myp-messages-detail>
      }
    </div>
  </div>
</div>

<ng-template #threadItem let-thread="thread" let-archived="archived">
  @if (thread.connection) {
    <li
      tabindex="0"
      class="menu-option detailed"
      (keyup.enter)="appService.mobileMenuShown = false; selectThread(thread)"
      (click)="appService.mobileMenuShown = false; selectThread(thread)"
      [class.active]="thread.id == selectedThread?.id"
      [class.archived]="archived"
    >
      <div class="primary-option">
        <div class="d-flex align-items-center">
          <img
            class="image-border round align-top"
            [class.viewing]="communityService.viewing[thread.id] && communityService.viewing[thread.id][thread.them]"
            [src]="thread.connection?.photoURL || './assets/images/default_avatar.jpg'"
          />
          <div>
            <span class="title">{{ thread.connection?.firstName + " " + thread.connection?.lastName }}</span>
            @if (thread.latestMessage) {
              <div>
                <span class="msg-extra-info">{{ helperService.stripHtml(thread.latestMessage.message) }}</span>
                <span class="msg-extra-info-date">{{ thread.latestMessage.timestamp.toDate() | date: "MMM Do [at] hh:mm" : true }}</span>
              </div>
            }
          </div>
        </div>
        <div class="d-flex align-items-center">
          <fa-icon icon="ellipsis-h" (click)="messageOptions(thread, $event)" placement="left" [ngbTooltip]="'sphere.options' | translate" class="action circle-icon-btn"></fa-icon>
          @if (communityService.activeThread?.id != thread.id && communityService.unreadCounts.threads[thread.id] && communityService.unreadCounts.threads[thread.id] > 0) {
            <span class="unread-messages-badge">
              {{ communityService.unreadCounts.threads[thread.id] }}
            </span>
          }
        </div>
      </div>
    </li>
  }
</ng-template>
